import React,{ useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from 'react-bootstrap';
import { KTIcon } from '../../../_metronic/helpers';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToastMessageSuccess, showToastMessageError, showToastMessageWarning } from '../../modules/Toast-Message/TosatMessage';
import { Send } from 'react-ionicons'
import CircleProgress from '../../components/CircleProgress';
import { InformationCircle } from 'react-ionicons'
import {OverlayTrigger,Tooltip} from 'react-bootstrap';

const API_URL = process.env.REACT_APP_API_URL;
const COMMIT_URL = `${API_URL}/deal-commit`;
const COMMIT_MULTIPLE = `${API_URL}/deal-commit-multiple`;

const userDetails = localStorage.getItem('kt-auth-react-v');
    const myUser = JSON.parse(userDetails);

const modalsRoot = document.getElementById('root-modals') || document.body;

const AddCommits = ({ show, handleClose, propsData, changedColor, changedSize }) => {

    const navigate = useNavigate();

    const [commitValue, setCommitValue] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [commitValues, setCommitValues] = useState({});

    const addMyCommits = async (deal_id, commited_qty) => {
        if (commitValue == 0 || commitValue === "") {
            setErrorMsg("enter commit quantity");
        } else {
            setErrorMsg("");

            await axios.post(COMMIT_URL, {
                deal_id: deal_id,
                commited_qty: commited_qty,
                stock_id: changedSize.stock_id ? changedSize.stock_id : propsData.default_color.sizes[0].stock_id,
                commission: changedSize.commission ? changedSize.commission : propsData.default_color.sizes[0].commission,
                price: changedSize.price ? changedSize.price : propsData.default_color.sizes[0].price,
                agent_commission:changedSize.agent_commission ? changedSize.agent_commission : propsData.default_color.sizes[0].agent_commission,
                attribute_code: changedColor.attribute_code ? changedColor.attribute_code : propsData.default_color.attribute_code,
                varient_code: changedSize.varient_code ? changedSize.varient_code : propsData.default_color.sizes[0].varient_code,
            })
                .then((response) => {
                    setCommitValue(0);
                    showToastMessageSuccess(response.data.message);
                    setTimeout(() => {
                        // navigate("/mycommitments");
                        handleClose();
                    }, 3000);
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.data) {
                        const errorResponse = error.response.data;
                        if (errorResponse.data) {
                            const fieldErrors = errorResponse.message;
                            showToastMessageError(fieldErrors);
                            setErrorMsg(fieldErrors);
                        }
                    } else {
                        showToastMessageError('An error occurred.');
                    };
                });
        };
    };

    // const myCommits = async ()=>{
    //     console.log(commitValues);

    //     const payload = Object.entries(commitValues).map(([key,value])=>{
            
    //     }) 
    //     await axios.post(MY_COMMITS,{

    //     }).then((response)=>{
    //         setCommitValues
    //     })
    // }

    const saveSingleCommit = async (key,commited_qty,varientId,productAttributeId,dealId,stockId,Price,Commission,agentCommission) => {
        if (commited_qty == 0 || commited_qty === "") {
            setErrorMsg("enter commit quantity");
        } else {
            setErrorMsg("");

            await axios.post(COMMIT_URL, {
                deal_id: dealId,
                commited_qty: commited_qty,
                stock_id: stockId,
                commission: Commission,
                price: Price,
                agent_commission:agentCommission,
                attribute_code: productAttributeId,
                varient_code: varientId,
            })
                .then((response) => {
                    if(response.data.data.status == false){
                        showToastMessageWarning(response.data.message);
                    }else{
                        showToastMessageSuccess(response.data.message);
                    }
                    setTimeout(() => {
                        // navigate("/mycommitments");
                        handleClose();
                    }, 3000);
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.data) {
                        const errorResponse = error.response.data;
                        if (errorResponse.data) {
                            const fieldErrors = errorResponse.message;
                            showToastMessageError(fieldErrors);
                            setErrorMsg(fieldErrors);
                        }
                    } else {
                        showToastMessageError('An error occurred.');
                    };
                });
        };
    };

    const saveMultipleCommit = async ()=>{
        console.log(commitValues);
        const dealId = propsData.deal_code;
        const payload = Object.entries(commitValues).filter(([_, value]) => value.commit_qty != 0)
        .map(([_, value]) => ({
            ...value
        }));

        console.log('dealId',dealId);
        console.log('payload',payload);
        

        try {
            await axios.post(COMMIT_MULTIPLE,{
                deal_id: dealId,
                commits:payload
            }).then((response)=>{
                if(response.data.data.status == false){
                    showToastMessageWarning(response.data.message);
                }else{
                    showToastMessageSuccess(response.data.message);
                }
                setTimeout(() => {
                    handleClose();
                }, 3000);
            })
        } catch (error) {
            if (error.response && error.response.data) {
                const errorResponse = error.response.data;
                if (errorResponse.data) {
                    const fieldErrors = errorResponse.message;
                    showToastMessageError(fieldErrors);
                    setErrorMsg(fieldErrors);
                }
            } else {
                showToastMessageError('An error occurred.');
            };
        }
    }

    const handleCommitChange = (e) => {
        const newValue = e.target.value.replace(/[^0-9]/g, '');
        setCommitValue(newValue);
    };


    useEffect(() => {
    const initial = {};
    propsData.colors.forEach((colorItem) => {
        colorItem.sizes.forEach((varient) => {
            const key = `${colorItem.color}-${varient.size}`;
            initial[key] = {
                varient_id:varient.varient_code,
                attribute_code:varient.product_attribute_id,
                deal_id:colorItem.deal_id,
                stock_id:varient.stock_id,
                price:varient.price,
                commission:varient.commission,
                agent_commission:varient.agent_commission,
                commit_qty:0
            }
        });
    });
    setCommitValues(initial);
}, [propsData.colors]);


const handleInputChange = (key, value) => {
    setCommitValues(prev => ({
        ...prev,
        [key]: {
            ...prev[key],
            commit_qty:value
        }
    }));
};

    // useEffect(() => {
    //     console.log("changedColor", changedColor);
    // }, [changedColor]);
    
     const itemPrice = (val) => {
        var data = {};
        if (propsData?.commission_status == 1) {
            const commission = parseFloat(val.commission);
            data = {
                orderPrice: parseFloat(val.price),
                actualPrice: parseFloat(val.price),
                commission: commission,
                total: parseFloat(val.price) + commission,
            };
        } else if (propsData?.retail == 1) {
            data = {
                orderPrice: parseFloat(val.price),
                actualPrice: parseFloat(val.price),
                commission: 0,
                total: parseFloat(val.price),
            };
        } else if (propsData?.below_cost == 1) {
            data = {
                orderPrice: parseFloat(val.price),
                actualPrice: parseFloat(val.price),
                commission: 0,
                total: parseFloat(val.price),
            };
        };
        return data;
    };

    return createPortal(
        <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-900px'
            show={show}
            onHide={handleClose}
            backdrop={true}
        >
            <div className='modal-header pb-0 border-top border-5 border-warning'>
                <h2>Add Commitment</h2>
                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
                    <KTIcon className='fs-1' iconName='cross' />
                </div>
            </div>
            <ToastContainer />

            <div className='col-sm-12'>
                <div className='card'>
                    <div className='card-body '>
                        <div className="row">
                            <div className="card-rounded text-center col-sm-3">
                                <img src={propsData.default_color?.image} alt='' style={{ width: "200px", height: "200px", objectFit: "contain" }} />
                            </div>
                            <div className='shadow-xs col-sm-9 card-rounded p-5  z-index-1 bg-body' >
                                <div className='d-flex align-items-center'>
                                    <div className='d-flex align-items-center flex-wrap w-100'>
                                        <div className='mb-1 pe-3 flex-grow-1'>
                                            <a href='#' className='fs-5 text-gray-700 text-hover-primary'>
                                                <strong>{propsData.name}</strong>
                                            </a>
                                            <div className="row mt-5">
                                                <div className="col-9">
                                                    {propsData.colors.map((item,index)=>(
                                                        <React.Fragment key={index}>
                                                        {item.sizes.map((varient,index)=>{
                                                            const key = `${item.color}-${varient.size}`;
                                                            const percentageValue = (varient.commited_qty / varient.stock) * 100;
                                                            const percentage = Math.round(percentageValue);
                                                            return(
                                                                <div className="commit-item mx-2 my-2" key={key}>
                                                                <div className="row d-flex">
                                                                <div className="col-2 perfect-center">
                                                                    <CircleProgress percentage={percentage}/>
                                                                </div>
                                                                <div className="col-7 d-flex align-items-center">
                                                                    <input type="number"
                                                                    className='commit-input-tiny'
                                                                    value={commitValues[key]?.commit_qty ?? 0}
                                                                    onChange={(e) => handleInputChange(key, e.target.value)}
                                                                        />
                                                                    <h6 className='ms-2 text-dark fs-5'>{item.color} {(varient.size != 'OS') ? varient.size_name : ''}</h6>
                                                                </div>
                                                                <div className="col-3 d-flex align-items-center">
                                                                        <OverlayTrigger
                                                                        key="top"
                                                                        placement='top'
                                                                        className='mt-2'
                                                                        overlay={
                                                                            <Tooltip id={`tooltip-top`} style={{maxWidth: '400px'}}>
                                                                                <span>Price : ${varient.price}</span><br />
                                                                                <span>Commission : ${(propsData.commission_status == 1) ? varient.commission : 0.00}</span>
                                                                            </Tooltip>
                                                                        }
                                                                        >
                                                                        <span><InformationCircle
                                                                            color={'deepskyblue'} 
                                                                            height="25px"
                                                                            width="25px"
                                                                        /></span>
                                                                        </OverlayTrigger>
                                                                    {/* <button type='button' onClick={() => myCommits} className='ms-2 btn btn-sm btn-primary'>Save</button> */}
                                                                    <button type='button' onClick={() => saveSingleCommit(key,commitValues[key].commit_qty,varient.varient_code,varient.product_attribute_id,propsData.deal_code,varient.stock_id,varient.price,varient.commission,varient.agent_commission)} className='ms-2 btn btn-sm btn-primary'>Save</button>
                                                                </div>
                                                                </div>
                                                            </div>
                                                            )
                                                        })}
                                                        </React.Fragment>
                                                    ))}
                                                    <div className="d-flex align-items-center justify-content-center">
                                                <div className='footer_btn2 me-5'>
                                                    <button type='button' onClick={() => {
                                                        saveMultipleCommit();
                                                    }} className=''>Commit&nbsp;&nbsp;<Send color={'white'}  height="15px" width="15px" /></button>
                                                </div>
                                            </div>
                                                </div>
                                            </div>
                                            

                                            {/* <div className='d-flex align-items-center mt-5  '>
                                                <div className='form-group mt-5'>
                                                    <input
                                                        type='text'
                                                        value={commitValue}
                                                        onChange={handleCommitChange}
                                                        className='form-control'
                                                        placeholder='Enter Quantity'
                                                    />
                                                    {errorMsg && <p className='position-absolute text-danger fw-semibold' style={{ marginTop: "-3px" }}>{errorMsg}</p>}
                                                </div>
                                                <div className='footer_btn2 me-5'>
                                                    <button type='button' onClick={() => {
                                                        addMyCommits(propsData.deal_code, commitValue);
                                                    }} className=''>Commit&nbsp;&nbsp;<Send color={'white'}  height="15px" width="15px" /></button>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>,
        modalsRoot
    );
}

export { AddCommits };
